import { useRootStore } from '../stores/root';
import { initSupportUser, clearSupportUser } from './supportUser';
import router from '../router';
import { retrieveTokensAndSetCookies } from './token_extraction';
import { isArray, isRecord } from './type_guards';

export default async function changeClient(rawOrgId: string) {
  const orgId = rawOrgId.startsWith('org-') ? rawOrgId : `org-${rawOrgId}`;
  // console.log('changeClient', {
  //   orgId,
  //   type: typeof orgId,
  // });
  const store = useRootStore();

  store.patches = null;
  store.hierarchyByUser = null;
  store.favoritePages = null;
  // store.businessUnits = null;
  localStorage.setItem('assumedOrgId', orgId);
  // remove multiOrgUserSelectedOrgId
  localStorage.removeItem('multiOrgUserSelectedOrgId');
  localStorage.removeItem('cimtToken');
  localStorage.removeItem('ebosLoginDone');

  const user: Record<string, unknown> = isRecord(store.user) ? store.user : {};
  const orgs = isArray(user.organizations) ? user.organizations : [];

  await clearSupportUser(store.userId, orgs, orgId);
  await initSupportUser(store.userId, orgId, orgs);
  await store.reload();

  await retrieveTokensAndSetCookies();
  await router.push('/home-dashboard');
  // window.location.reload();

  // await router.replace('/home-dashboard');
  // router.go(0);

  store.remountApp();

  const { origin } = window.location;
  window.location.assign(`${origin}/home-dashboard`);
}
